/* eslint-disable */
import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';
import authReducer from './app/auth/AuthSlice';
import applicationsReducer from './features/account-dashboard/ApplicationsSlice';
import wipApplicationReducer from './features/apply-for-registration/DraftApplicationSlice';
import profileReducer from './features/profile-settings/ProfileSlice';
import licensesReducer from './features/vacation-rentals-bnb/VacationRentalSlice';
import cartReducer from './features/cart/CartSlice';
import todoReducer from './features/_old/todo/TodoSlice';
import registeredAppReducer from './features/registration/RegistrationsSlice';
import profileVerificationReducer from './features/verifications/VerificationsSlice';

const rootReducer = combineReducers({
  todo: todoReducer,
  auth: authReducer,
  draftApplication: wipApplicationReducer,
  profile: profileReducer,
  applications: applicationsReducer,
  licenses: licensesReducer,
  cart: cartReducer,
  registeredApps: registeredAppReducer,
  profileVerifications: profileVerificationReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<R = void> = ThunkAction<
  R,
  RootState,
  unknown,
  Action<string>
>;
export type ReduxStore = typeof store;

export { store };
